import {getElementByElementOrId, identifyElement} from "./helpers/element";
import {MixinHtmlClassState} from "./mixins/html_class_state";
import {MixinDatasetConfigurable} from "./mixins/dataset_configurable";

// Base component class takes a props object.
// Generally includes a `element` property and a `config` property.
// The config property should include a `baseHtmlClass` and `selector`.
export default class Component {

    // Check if an element is already inited with a specific type of component.
    static isElementComponentized(element, signature) {
        if (!element.hasOwnProperty('componentizedWith')) return false;
        if (!Array.isArray(element.componentizedWith)) return false;
        return element.componentizedWith.includes(signature);
    }

    static createElement(baseHtmlClass, options={}) {
        const tagName = options.tagName || 'div';
        let element = document.createElement(tagName);
        const htmlClass = `${ baseHtmlClass }`;
        element.setAttribute("class", htmlClass);
        this.content = null;
        return element;
    }

    constructor(props = {}) {
        MixinHtmlClassState(this); // Add the HTML class state management methods.

        MixinDatasetConfigurable(this); // Add methods to gather configuration key/value pairs from the elements dataset attributes.

        this.render = this.render || function() {}; // Placeholder render method.

        this.element = (props.hasOwnProperty('element') ? getElementByElementOrId(props.element) : null);
        if (!this.element) { console.warn(`[Component] Element not found! Are the props correct?`, props) }

        this.id = identifyElement(this.element);
        if (this.element) this.element.component = this;

        const config = (props.hasOwnProperty('config') ? props.config : {});
        this.configure(config);

        this.markElementComponentized(this.signature);
    }

    // Set important component properties from any supplied config.
    configure(config){
        this.config = config;
        this.signature = (config.hasOwnProperty('signature') ? config.signature : null);
        this.baseHtmlClass = (config.hasOwnProperty('baseHtmlClass') ? config.baseHtmlClass : null);
        this.selector =      (config.hasOwnProperty('selector')      ? config.selector      : null);
    }

    // Sign the component's signature to the element's "componentizedWith" array.
    // The 'Component.isElementComponentized` method checks this property to see if an element is already inited with any specific type of component.
    markElementComponentized(signature){
        if (!signature) return;
        if (this.element.hasOwnProperty('componentizedWith')) {
            this.element.componentizedWith.push(signature);
        } else {
            this.element.componentizedWith = [signature];
        }
    }

}
